import api from './axios';

export const listar    = ()   => api.get('/pedidos/');
export const buscarId  = (id) => api.get(`/pedidos/${id}`);
export const finalizar = (id) => api.post(`/pedidos/${id}/finalizar`);
export const cancelar  = (id) => api.post(`/pedidos/${id}/cancelar`);
